import React from 'react';

export default class Page8 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToMakeTimelyDecisions');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Talk to a role model</div>
                                            <p>Is there someone you know who is good at making timely
                                                decisions? If so, talk to them – they
                                                may help you by talking about their own experiences.</p>
                                            <div className="border_subtitle">Discuss the ‘Have you made your
                                                mind up yet?’ exercise
                                            </div>
                                            <p>Arrange a meeting with three key people; one could be your
                                                mentor, the second your line manager
                                                and the third a member of your team. Using the ‘Have you
                                                made your mind up yet?’ exercise we
                                                described earlier, ask each for feedback under step 3.
                                                They’ll have different perspectives about
                                                your skills and may raise issues you didn’t think of when
                                                you did the exercise for yourself – all of
                                                which will further your development.</p>
                                            <p>Set up another, future meeting and ask the same people if
                                                they notice any change in your
                                                decision making processes, and anything you could still
                                                improve.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Make improving these skills a formal objective and include it
                                                in your personal development plan,
                                                or create one, making this a starting point. Give yourself
                                                clear objectives and specific actions to
                                                help you make noticeable progress.</p>
                                            <div
                                                className="lightgreencontentbg uiheading keyquestionpadnew lightbgcenter">
                                                <p>Remember that the best way to avoid falling into any of
                                                    the individual or group decision
                                                    making biases is to be aware of them: <span
                                                        className="green brownbold"> Forewarned is forearmed.</span>
                                                </p>
                                            </div>
                                            <p></p>

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
                Further Information
                </span></div>

                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToPrioritiseTasksReadyForAction')}>How
                                                        to prioritise tasks ready for action</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMakeEthicalDecisions')}>How
                                                        to make ethical decisions</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToBeConfidentInYourJudgementCalls')}>How
                                                        to be confident in making judgement calls</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToBalanceRiskWithPotentialBenefits')}>How
                                                        to balance risk with potential benefits.</div></li>

                                                </ul>
                                            </div>
                                            <p></p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content"> Kahneman, D.,
                                                    Tversky, A. &amp; Slovic, P. (eds.) (1982).<span
                                                        className="subtiltereg"> Judgement under Uncertainty: Heuristics &amp; Biases.</span> Cambridge,
                                                    UK: Cambridge University Press.</p></li>
                                                <li><p className="further_info_content"> Cropanzano,
                                                    R., &amp; Wright, T. (1999). A five-year study of the
                                                    relationship between wellbeing and
                                                    performance.<span className="subtiltereg"> Journal of Consulting Psychology,</span> 51,
                                                    252-265.</p></li>
                                                <li><p className="further_info_content"> Asch, S. (1956).
                                                    Studies of independence and conformity: A minority of
                                                    one against a unanimous majority. <span
                                                        className="subtiltereg"> Psychological Monographs,</span> 70
                                                    (Whole no. 416).</p></li>
                                                <li><p className="further_info_content"> Moscovici, S.
                                                    (1976). <span className="subtiltereg"> Social influence and social change.</span> London:
                                                    Academic Press.</p></li>
                                                <li><p className="further_info_content"> Milgram, S. (1963).
                                                    Behavioral study of obedience. <span
                                                        className="subtiltereg"> Journal of Abnormal and Social Psychology,</span> 67,
                                                    371-378.</p></li>
                                                <li><p className="further_info_content"> Janis, I.
                                                    (1972). <span
                                                        className="subtiltereg"> Victims of groupthink.</span> Boston:
                                                    Houghton-Mifflin.</p></li>
                                                <li><p className="further_info_content"> Buzan, T
                                                    (2006). <span className="subtiltereg"> The Ultimate Book of Mind Maps.</span>Harper
                                                    Thorsons.</p></li>
                                                <li><p className="further_info_content"> De Bono, E.
                                                    (1985) <span
                                                        className="subtiltereg">  Six Thinking Hats.</span> Little,
                                                    Brown and Company.</p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}